import ConsultarSolicitudesContent from './ConsultarSolicitudes/ConsultarSolicitudesContent';

import React from 'react';
import {useJumboApp} from "@jumbo/hooks";
import {LAYOUT_NAMES} from "../../../layouts/layouts";


const ConsultarSolicitudesPage = () => {
  const {setActiveLayout} = useJumboApp();

  React.useEffect(() => {
      setActiveLayout(LAYOUT_NAMES.VERTICAL_DEFAULT);
  }, []);
  return (
    <div>
        <h2>Solicitudes generadas por el usuario.</h2>
            <ConsultarSolicitudesContent/>
      </div>
  );
};

export default ConsultarSolicitudesPage;